import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {UserCarrierForm} from "./UserCarrierForm";

export const UserCarrierEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <UserCarrierForm />
    </DefaultEdit>
  );
};
